import { useMemo } from 'react';
import useAuth from '../../../hooks/useAuth';
import { Link } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import Logo from "../../../assests/images/logo.png";
import { useTheme } from '@mui/material/styles';
import customButton from './customButton';

const linkTheme = () => ({
  textDecoration: 'none', color: 'black'
});

const Navbar = () => {

  const { token, logout } = useAuth();
  const theme = useTheme();

  const buttonTheme = useMemo(() => {
    return {
      color: theme.mainColor, fontSize: "16px", fontWeight: "bold", borderRadius: "7px", height: "40px", px: "9px", border: "1.5px solid #990000", transition: "box-shadow 0.15s ease, transform 0.15s ease",
      '&:hover': {
        backgroundColor: 'white', color: theme.mainColor, borderRadius: "7px", transform: "translateY(-0.1em)"
      },
    }
  }, [theme.mainColor]);

  const pages = useMemo(() => {
    return ['home', 'contact', 'about'];
  }, []);

  return (
    <Stack direction="row" spacing={2} sx={{ justifyContent: "space-between", alignItems: "center", backgroundColor: "white", height: "65px", top: 0, width: "100%", borderRadius: "6px" }}>
      <Link to="/" style={{ ...linkTheme }}>
        <Stack direction="row" spacing={2} sx={{ justifyContent: "center", alignItems: "center", pl: 2 }}>
          <Box
            component="img"
            sx={{
              height: 60,
            }}
            alt="CyberBank Logo"
            src={Logo}
          />
        </Stack>
      </Link>
      <Stack
        direction="row"
        spacing={1.5}
        sx={{ pr: 2, justifyContent: "center", alignItems: "center" }}
      >
        {pages.map((page) => (
          <Link key={page} to={`/${page}`} style={{ ...linkTheme }}>
            <Button sx={{ ...buttonTheme }} >
              {page.split("-").join(" ")}
            </Button>
          </Link>
        ))}
        {token ?
          <Link to={'/banking'} style={{ ...linkTheme }}>
            <Button sx={{ ...customButton }} >
              Banking
            </Button>
          </Link> :
          <Link to={'/sign-up'} style={{ ...linkTheme }}>
            <Button sx={{ ...customButton }} >
              Sign Up
            </Button>
          </Link>
        }
        {token ?
          <Button sx={{ ...customButton }} onClick={() => logout()}>
            Logout
          </Button> :
          <Link to={'/login'} style={{ ...linkTheme }}>
            <Button sx={{ ...customButton }} >
              Login
            </Button>
          </Link>
        }
      </Stack>
    </Stack>
  );
}

export default Navbar;